export function accessReducer(state = {
    PAGES: [],
    CONFIG: [],
    WIDGETS: [],
},{
    type,
    payload
}){
    
    switch(type){
        case "GET_PAGES":
            let list = Object.assign({}, state)
            list.PAGES = payload
            return list;
            
        case "GET_CONFIG_PAGES":
            let list2 = Object.assign({}, state)
            list2.CONFIG = payload
            return list2;
            
        case "GET_WIDGETS":
            let list3 = Object.assign({}, state)
            list3.WIDGETS = payload
            return list3;

        case "GET_TOKENS":
            return payload;
        default:
            return state;
    }
    
}

